import React, { Component } from 'react';
import { withRouter, Link } from "react-router-dom";
import { FormControl, FormGroup, Row, Col, Button, Modal, Alert} from 'react-bootstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/fontawesome-free-solid';
import { msgs } from 'src/js/ErrorMessage.js';
import 'src/css/LoginForm.css';
import 'src/i18n';
import { withTranslation, Trans } from 'react-i18next';

class Verification extends Component {

  // TODO
  // VinNoの入力を、遷移前の画面の入力を引き継ぐことによってスキップする
  //
  constructor() {
    super();
    this.state = {
      showModal: false,
      errorMessage: ''
    }

    // 画面最上部まで移動
    window.scrollTo(0,0);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleShowModal = this.handleShowModal.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {

    let _this = this;

    this.setState({
      isEmpty: false,
      isNotOK: false
    })

    let pass1 = this.inputPassword1.value;
    let pass2 = this.inputPassword2.value;

    // パスワードにおいて、1度目と2度目の入力が同じかチェック
    if (pass1 !== pass2){
        // エラーポップアップ
        _this.setState({
          isEmpty: true,
          errorMessage: <Trans i18nKey="Message.PasswordsDoNotMatch">Passwords do not match.</Trans>
        })
        this.inputPassword1.value = ''
        this.inputPassword2.value = ''
        return;
    }

    if(this.inputUserName.value === '' || this.inputVerificationCode.value === '' || pass1 === ''){
      this.setState({
        isEmpty: true,
        isNotOK: true,
        errorMessage: <Trans i18nKey="Message.PleaseCompleteAllForms">Please complete all forms.</Trans>
      })
      return;
    }

    this.props.setNewPassword(this.inputUserName.value, pass1, this.inputVerificationCode.value);
  }
  
  
  handleHideModal() {
    
    this.setState(
        {
          isEmpty: false,
          showModal: false
        }
      );
  }
  
  handleShowModal() {
    this.setState({showModal: true });
  }

  render() {
    const {t} = this.props;
    
    const Error = () => (
      <div>
        {
          this.props.setNewPassFail ? <Alert bsStyle="danger">
          <p>
              <Trans i18nKey={"Message." + msgs[this.props.errMsgIndex]}>
               {msgs[this.props.errMsgIndex]}
              </Trans>
            </p>
            </Alert> : false
        }
      </div>
    );

    const VerificationButton = () => (
      <button type="submit" id="circleButton" disabled={this.props.setNewPassLoading} onClick={this.onClick}>
        {
          this.props.setNewPassLoading ? <FontAwesomeIcon size='1x' icon={faSpinner} spin /> : <Trans i18nKey="Verification.Verify">Verify</Trans>
        }
      </button>
    );

    const BackButton = () => (
      <Row>
        <Col md={12} sm={12} xs={12}>
          <Link to="/forgotpass"> 
            <Button bsStyle="link" className="backButton">&lt;&lt; <Trans i18nKey="ForgotPasswordVerification.Back">Back to forgot password page</Trans></Button>
          </Link>
        </Col>
      </Row>
    );

    return (
      <div>
        <Row>
          {(this.state.isEmpty || (this.props.isVerificationFailed && !this.state.isNotOK)) &&(
            <Modal show={true} onHide={this.handleHideModal} dialogClassName="check-modal">
            <Modal.Body>
              {this.state.errorMessage}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.handleHideModal}>OK</Button>
            </Modal.Footer>
          </Modal>
          )}
        </Row>
        <BackButton />
        <Row>
          <Col xs={10} xsOffset={1}>
            <Error />
          </Col>
        </Row>
        {/* ユーザ名入力フォーム */}
        <FormGroup controlId="formHorizontalId" >
          <Row>
            <Col xsOffset={1} xs={10}>
              <p className="formText"><Trans i18nKey="Common.ID">VIN No.</Trans></p>
            </Col>
          </Row>
          <Row>
            <Col xsOffset={1} xs={10}>
              <FormControl className="form" type="text" bsSize="large" componentClass="input" 
              inputRef={(ref) => { this.inputUserName = ref }} />
            </Col>
          </Row>
        </FormGroup>
        {/* 認証コード入力フォーム */}
        <FormGroup controlId="formHorizontalPassword">
          <Row>
            <Col xsOffset={1} xs={10}>
              <p className="formText"><Trans i18nKey="Verification.VerificationCode">Verification Code(six digits)</Trans></p>
            </Col>
          </Row>
          <Row>
            <Col xsOffset={1} xs={10}>
              <FormControl className="form" type="text" bsSize="large" componentClass="input" inputRef={(ref) => { this.inputVerificationCode = ref }} />
            </Col>
          </Row>
        </FormGroup>
        {/* パスワード入力フォーム */}
        <FormGroup controlId="formHorizontalPassword1">
          <Row>
            <Col xsOffset={1} xs={10}>
              <p className="formText"><Trans i18nKey="Common.Password">Password</Trans></p>
              <p className="formTextDescription"><Trans i18nKey="SignUp.PasswordDescription">(Requirements - Minimum length 8)</Trans></p>
            </Col>
          </Row>
          <Row>
            <Col xsOffset={1} xs={10}>
              <FormControl className="form" type="password" bsSize="large" componentClass="input" inputRef={(ref) => { this.inputPassword1 = ref }} />
            </Col>
          </Row>
        </FormGroup>
        {/* パスワード再入力フォーム */}
        <FormGroup controlId="formHorizontalPassword2">
          <Row>
            <Col xsOffset={1} xs={10}>
              <p className="formText"><Trans i18nKey="SignUp.PasswordConfirm">Password(Re-enter for confirmation)</Trans></p>
            </Col>
          </Row>
          <Row>
            <Col xsOffset={1} xs={10}>
              <FormControl className="form" type="password" bsSize="large" componentClass="input" inputRef={(ref) => { this.inputPassword2 = ref }} />
            </Col>
          </Row>
        </FormGroup>
        {/* 認証ボタン */}
        <FormGroup>
          <Row id="button-forms">
            <VerificationButton />
            <Col className="HeartLogo" md={4} sm={4} xs={10} mdOffset={4} smOffset={4} xsOffset={1}></Col>
          </Row>
        </FormGroup>
        <div className='mini-div' />
      </div>
    );
  }
}

export default withTranslation()(withRouter(Verification));



// WEBPACK FOOTER //
// ./src/component/ForgotPass/ForgotPassVerification.js